import { isRecord } from '@/shared/utils/apiResponse';

import type {
  WhatsappTemplateLinesResponse,
  WhatsappTemplateOriginLine,
} from '../types/adminTemplates';

function isWhatsappTemplateOriginLine(value: unknown): value is WhatsappTemplateOriginLine {
  return (
    isRecord(value) &&
    typeof value.id === 'string' &&
    value.id.trim().length > 0 &&
    typeof value.numero === 'string' &&
    value.numero.trim().length > 0 &&
    typeof value.wabaId === 'string' &&
    value.wabaId.trim().length > 0 &&
    (value.tipo === 'NEGOCIACAO' || value.tipo === 'NOTIFICACAO' || value.tipo === 'ARBITRAGEM')
  );
}

export function isWhatsappTemplateLinesResponse(
  value: unknown,
): value is WhatsappTemplateLinesResponse {
  if (!isRecord(value) || value.success !== true || !isRecord(value.data)) return false;
  const page = value.data;
  return (
    Array.isArray(page.items) &&
    page.items.every(isWhatsappTemplateOriginLine) &&
    typeof page.page === 'number' &&
    Number.isInteger(page.page) &&
    page.page > 0 &&
    typeof page.limit === 'number' &&
    Number.isInteger(page.limit) &&
    page.limit > 0 &&
    typeof page.total === 'number' &&
    Number.isInteger(page.total) &&
    page.total >= 0 &&
    typeof page.hasMore === 'boolean' &&
    (page.selecionada === null || isWhatsappTemplateOriginLine(page.selecionada))
  );
}
